import { BarChart3, Briefcase, Code, Languages, Trophy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Skills = ({ skills, certifications }) => {
  const getCategoryIcon = (category) => {
    const iconMap = {
      'Financial Analysis': BarChart3,
      'Business Strategy': Briefcase,
      'Technical Tools': Code,
      'Leadership': Trophy,
      'Languages': Languages
    };
    return iconMap[category] || Code;
  };

  return (
    <section id="skills" className="py-20 bg-[#0D1117]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Skills & Expertise
          </h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto">
            Comprehensive skill set spanning finance, business strategy, and leadership
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {skills.map((skill, index) => {
            const Icon = getCategoryIcon(skill.category);
            return (
              <Card key={index} className="border-white/10 bg-white/5 backdrop-blur-sm shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1">
                <CardHeader>
                  <CardTitle className="flex items-center gap-3 text-white">
                    <div className="w-10 h-10 rounded-lg bg-[#9A7B4F]/20 flex items-center justify-center">
                      <Icon className="text-[#9A7B4F]" size={20} />
                    </div>
                    {skill.category}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-wrap gap-2">
                    {skill.items.map((item, idx) => (
                      <Badge
                        key={idx}
                        variant="secondary"
                        className="bg-white/10 text-white/80 hover:bg-white/20 border-none"
                      >
                        {item}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Certifications */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">
            Certifications & Courses
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {certifications.map((cert, index) => (
              <Badge
                key={index}
                className="bg-[#9A7B4F] hover:bg-[#C4A76C] text-white px-4 py-2 text-sm shadow-lg"
              >
                {cert}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;